// extracted by mini-css-extract-plugin
export var content = "_65-3";
export var list = "_65-4";
export var settingsContent = "_65-7";
export var settingsPanel = "_65-8";
export var state = "_65-6";
export var triggerBadge = "_65-2";
export var triggerButton = "_65-1";
export var triggerShell = "_65-0";
export var unreadDot = "_65-5";